var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useRef, useEffect, } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { accountApi } from '../api/common/account';
import { isRecaptchaEnabled, minimumRecaptchaLength } from '../utils/general';
import { RECAPTCHA_ACTION } from '../constants/recaptcha';
var ProfileContext = React.createContext(null);
var ProfileProvider = function (_a) {
    var children = _a.children, isB2B = _a.isB2B;
    var isMounted = useRef(false);
    var executeRecaptcha = useGoogleReCaptcha().executeRecaptcha;
    useEffect(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    var getRecaptchaToken = useCallback(function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = '';
                    if (!(executeRecaptcha && isRecaptchaEnabled(isB2B))) return [3 /*break*/, 3];
                    return [4 /*yield*/, executeRecaptcha(action)];
                case 1:
                    token = _a.sent();
                    if (!(!token || (token === null || token === void 0 ? void 0 : token.length) < minimumRecaptchaLength())) return [3 /*break*/, 3];
                    return [4 /*yield*/, executeRecaptcha(action)];
                case 2:
                    token = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, token];
            }
        });
    }); }, [executeRecaptcha, isB2B]);
    var _b = useState(null), customerData = _b[0], setCustomerData = _b[1];
    var getProfileData = useCallback(function () {
        return accountApi.profileDetails(isB2B).then(function (data) {
            if (isMounted.current) {
                setCustomerData(data);
            }
            return data;
        });
    }, [isB2B]);
    var updatePersonalDetails = function (requestData) { return __awaiter(void 0, void 0, void 0, function () {
        var action, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    action = isB2B
                        ? RECAPTCHA_ACTION.B2B_UPDATE_PERSONAL_DETAILS
                        : RECAPTCHA_ACTION.B2C_UPDATE_PERSONAL_DETAILS;
                    return [4 /*yield*/, getRecaptchaToken(action)];
                case 1:
                    token = _a.sent();
                    return [2 /*return*/, accountApi
                            .updateProfileDetails(requestData, isB2B, token)
                            .then(function (data) {
                            if (isMounted.current) {
                                setCustomerData(data);
                            }
                        })];
            }
        });
    }); };
    var updateCompanyDetails = function (requestData) { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getRecaptchaToken(RECAPTCHA_ACTION.B2B_UPDATE_COMPANY_DETAILS)];
                case 1:
                    token = _a.sent();
                    return [2 /*return*/, accountApi.updateCompanyDetails(requestData, token).then(function (data) {
                            if (isMounted.current) {
                                setCustomerData(data);
                            }
                        })];
            }
        });
    }); };
    return (React.createElement(ProfileContext.Provider, { value: {
            isB2B: isB2B,
            customerData: customerData,
            getProfileData: getProfileData,
            updatePersonalDetails: updatePersonalDetails,
            updateCompanyDetails: updateCompanyDetails,
        } }, children));
};
export { ProfileProvider, ProfileContext };
